//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import currencyValue from '../../../../plugins/filters/currencyValue';

export default {
    props: ['product'],
    data() {
        return {
            errors: [],
            disabled: [],
            selectedOptions: {},
            selectedUid: [],
            candidateProduct: null,
            qty: 1,
            tooltip: `
                <div class="space-y-4">
                    <p>Liity kanta-asiakkaaksi ja säästä: Saat tämän tuotteen -5% edullisemmin</p>
                    <p>PS. Liittyminen on ilmaista eikä velvoita mihinkään ✓</p>
                </div>
                `,
            loading: false,
        };
    },
    computed: {
        discountAmount() {
            const product = this.candidateProduct ? this.candidateProduct.product : this.product;

            return product.price_range.minimum_price.discount.amount_off;
        },
        addToCartDisabled() {
            const product = this.candidateProduct ? this.candidateProduct.product : this.product;
            return product.stock_status === 'OUT_OF_STOCK';
        },
        priceTimesQty() {
            const value = parseFloat(this.qty * this.finalPrice) | currencyValue;

            return `${value} €`;
        },
        finalPrice() {
            const product = this.candidateProduct ? this.candidateProduct.product : this.product;
            let finalPrice = product.price_range.minimum_price.final_price.value;
            if (this.product.price_tiers?.length) {
                const tierPriceRules = product.price_tiers.filter((tier) => tier.quantity <= this.qty).sort((tierA, tierB) => tierB.quantity - tierA.quantity);
                const bestTierPriceRule = tierPriceRules.length > 0 ? tierPriceRules[0] : null;
                const bestTierPrice = bestTierPriceRule ? bestTierPriceRule.final_price.value : Infinity;

                if (bestTierPrice < finalPrice) {
                    finalPrice = bestTierPrice;
                }
            }

            return finalPrice;
        },
        hasStockWarning() {
            return this.candidateProduct && this.candidateProduct.product && this.candidateProduct.product['only_x_left_in_stock'];
        },
    },
    watch: {
        selectedOptions: {
            deep: true,
            handler(newVal) {
                const selected = JSON.parse(JSON.stringify(newVal));
                if (Object.keys(selected).length === this.product.configurable_options.length) {
                    const product = this.resolveVariant(this.product.variants, this.product, selected);
                    this.candidateProduct = product;
                    if (product) {
                        this.$root.$emit('candidateProduct', product);
                    }
                }
            },
        },
    },
    mounted() {
        if (this.$route && this.product.configurable_options) {
            let { query = {} } = this.$route;

            if (this.$route.hash && Object.values(query).length === 0) {
                const hashParams = new URLSearchParams(this.$route.hash.substring(1));
                query = Object.fromEntries(hashParams.entries());
            }

            this.product.configurable_options.forEach((option) => {
                const { attribute_id: attributeId, values } = option;
                if (query.hasOwnProperty(attributeId)) {
                    const matchingValue = values.find((value) => value.value_index === parseInt(query[attributeId]));
                    if (matchingValue) {
                        this.$set(this.selectedOptions, attributeId, matchingValue.uid);
                    }
                }
            });

            // MOT-212 select option if there's only one option
            const optionIds = this.product.configurable_options.map((option) => option.values.map((value) => value.uid)).flat(1);
            const intersection = [...this.product.variants].filter((variant) => variant.attributes.every((attribute) => optionIds.includes(attribute.uid)));

            if (intersection.length === 1) {
                const attributes = intersection[0].attributes.map((attribute) => attribute.uid);
                const option = this.product.configurable_options.find((option) =>
                    option.values.map((value) => value.uid).find((value) => attributes.includes(value)),
                );
                const optionValue = option.values.map((value) => value.uid).find((value) => attributes.includes(value));
                if (option && optionValue) {
                    this.$set(this.selectedOptions, option.attribute_id, optionValue);
                }
            }
        }
    },
    methods: {
        parseError(errorMessage) {
            if (errorMessage.trim() === 'The requested qty is not available') {
                return this.$t('error.cart.qtynotavailable');
            }
            if (errorMessage.startsWith('Sinun täytyy valita vaihtoehdot tuotteellesi')) {
                return this.$t('error.cart.selectvariant');
            }

            return errorMessage;
        },
        getOptionLabel(attributes, code) {
            return [...attributes].find((item) => item.code === code).label;
        },
        findVariant(code, value) {
            return [...this.product.variants].find((item) => item.attributes.find((attribute) => attribute.code === code && attribute.uid === value));
        },
        findVariantsStock(code, value) {
            const variants = [...this.product.variants].filter((item) =>
                item.attributes.find((attribute) => attribute.code === code && attribute.uid === value),
            );
            const stocks = variants.map((variant) => variant.product.stock_status);

            return stocks.includes('IN_STOCK');
        },
        resolveVariant(variants, configItem, selected) {
            this.disabled = [];
            const optionCodeMap = new Map();

            if (configItem) {
                configItem.configurable_options.forEach((option) => {
                    optionCodeMap.set(option.attribute_id, option.attribute_code);
                });
            }

            const mergedOptionSelections = new Map(Object.entries(selected));
            configItem.configurable_options.forEach((option) => {
                if (!mergedOptionSelections.has(`${option.id}`)) {
                    mergedOptionSelections.set(`${option.id}`, option.value_id);
                }
            });
            mergedOptionSelections.delete('undefined');
            const result = configItem.variants.find(({ attributes, product }) => {
                const customAttributes = (attributes || []).reduce((map, { code, uid }) => new Map(map).set(code, uid), new Map());

                for (const [id, value] of mergedOptionSelections) {
                    const code = optionCodeMap.get(id);
                    const matchesStandardAttribute = product[code] === value;
                    const matchesCustomAttribute = customAttributes.get(code) === value;

                    // if any option selection fails to match any standard attribute
                    // and also fails to match any custom attribute
                    // then this isn't the correct variant
                    if (!matchesStandardAttribute && !matchesCustomAttribute) {
                        return false;
                    }
                }

                // otherwise, every option selection matched
                // and this is the correct variant
                return product;
            });

            return result;
        },
        async submit(recursion) {
            this.loading = true;
            const payload = {
                sku: this.product.sku,
                quantity: this.qty,
            };
            if (this.candidateProduct) {
                payload['selected_options'] = Object.values(this.selectedOptions);
            }
            this.errors = [];
            try {
                const { cart, user_errors } = await this.$store.dispatch('cart/addProduct', {
                    items: [payload],
                    product: this.candidateProduct || this.product,
                });
                this.errors = user_errors;
                if (!this.errors.length) {
                    this.$emit('submit');
                }
            } catch (e) {
                if (recursion) {
                    if (
                        e.message.startsWith('GraphQL error: Could not find a cart with ID') ||
                        e.message.startsWith('GraphQL error: The current user cannot perform operations on cart') ||
                        e.message.startsWith('GraphQL error: Current user does not have an active cart.') ||
                        e.message.startsWith("GraphQL error: The cart isn't active.")
                    ) {
                        this.$storage.removeCookie('cart_id');
                        await this.$store.commit('cart/set_cart', {});
                        await this.$store.dispatch('cart/getCart');
                        await this.submit(true);
                    }
                } else {
                    this.$notify.error(e);
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
